<div class="form-group mb-0" style="position: relative;">
    <input type="text"
           class="form-control form-control-sm"
           [placeholder]="placeholder"
           [(ngModel)]="searchText"
           [ngModelOptions]="{standalone: true}"
           (input)="onInput()"
           (focus)="onInput()"
           (blur)="hideDropdownWithDelay()">
    <ul *ngIf="showDropdown" class="member-search-dropdown">
        <li *ngFor="let m of filteredMembers" (mousedown)="select(m)">{{ m.name }} ({{ m.email }})</li>
    </ul>
    <small *ngIf="value" class="text-success d-block mt-1">
        Linked to a member account
        <a href="javascript:void(0)" (mousedown)="clear()">(clear)</a>
    </small>
</div>
